var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "file-usage-container" }, [
    _setup.items.length
      ? _c(
          "ul",
          { staticClass: "list-group" },
          _vm._l(_setup.items, function (item) {
            return _c(
              "li",
              { key: item.id, staticClass: "list-group-item" },
              [_c(_setup.FormControlFilesUsageItem, { attrs: { item: item } })],
              1
            )
          }),
          0
        )
      : !_setup.isLoading
      ? _c(
          "div",
          { staticClass: "text-muted small p-2 border rounded bg-light" },
          [
            _c("i", { staticClass: "bi bi-info-circle me-1" }),
            _vm._v(
              "\n        This file is not currently linked to any content.\n    "
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _setup.isLoading
      ? _c("div", { staticClass: "p-2 text-center" }, [_vm._m(0)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "spinner-border spinner-border-sm text-secondary",
        attrs: { role: "status" },
      },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Loading usage..."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }